import { Component } from "@angular/core";
import { CatalogService } from "@app/services/catalog.service";
import { Angulartics2 } from "angulartics2";
import { ViewChild } from "@angular/core";
import { ElementRef } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { Catalog } from "@app/data/catalog";
import { Plan, User } from "@app/data/user";
import * as tearSheetUtils from "@js/tear-sheet.utils";
import { HostListener } from "@angular/core";
import { AfterViewInit } from "@angular/core";
import { DropzoneConfigInterface } from "ngx-dropzone-wrapper";
import { FileService } from "@app/services/file.service";
import { File } from "@data/file";

const MAX_HEIGHT = 800;
const MAX_WIDTH = 650;

@Component({
  templateUrl: "./flipbook.component.html",
})
export class FlipbookComponent implements AfterViewInit {
  dropzoneConfig: DropzoneConfigInterface = {
    url: "api/v2/files",
    maxFilesize: 50,
    acceptedFiles: "application/pdf",
    params: {
      filetype: "pdf",
    },
  };
  embedCode: String;
  pdfSource: File;
  pdfs: File[];
  user: User;
  userModel: User;
  pageContainerHeight: number = 0;
  pageContainerWidth: number = 0;
  zoom: number = 1;
  pageHeight: number = 0;
  pageWidth: number = 0;
  source: string = "file";
  catalogs: Catalog[];
  catalog: Catalog;
  catalogSource: Catalog;
  pdfURL: string;
  width: number = 990;
  height: number = 560;
  baseUrl: string;
  isShopify: boolean;
  plan: Plan;

  @ViewChild("workspaceElement")
  workspaceElement: ElementRef;

  constructor(
    private angulartics2: Angulartics2,
    private userService: UserService,
    private fileService: FileService,
    private catalogService: CatalogService
  ) {
    this.angulartics2.eventTrack.next({ action: "Opened Flipbook Page" });

    this.userService.me().then((user) => {
      this.plan = user.subscription.plan;
      this.setUserModel(user);
      this.isShopify = this.userService.isShopify(user);
    });
    this.loadCatalogs();
    this.loadPDFs();
    var getUrl = window.location;
    this.baseUrl = getUrl.protocol + "//" + getUrl.host;
  }
  loadCatalogs() {
    this.catalogService.getCatalogs("", 0).then((catalogs) => {
      this.catalogs = catalogs;
      if (this.catalogs.length > 0) {
        this.catalogs.sort(function (a, b) {
          return a.title.toLowerCase().localeCompare(b.title.toLowerCase());
        });
        this.catalogSource = this.catalogs[0];
        this.catalogSourceChanged(this.catalogSource);
      }
    });
  }
  protected sourceChanged() {
    if (this.source === "catalog") {
      this.loadCatalogs();
    } else if (this.source === "file") {
    }
  }

  @HostListener("window:resize") onResize() {
    this.refreshPageDimensions();
  }

  ngAfterViewInit(): void {
    var timerId = setInterval(() => {
      this.refreshPageDimensions();
      if (this.pageHeight > 100) {
        clearTimeout(timerId);
      }
    }, 300);
  }

  protected catalogSourceChanged(catalog: Catalog) {
    this.catalog = catalog;
  }

  protected setUserModel(user: User) {
    this.user = user;
    this.userModel = JSON.parse(JSON.stringify(this.user));
  }
  protected refreshPageDimensions() {
    if (this.userModel && this.workspaceElement) {
      let widthDPI = tearSheetUtils.toPx(
        this.userModel.settings.page_format === "A4"
          ? tearSheetUtils.A4_PAGE_WIDTH
          : tearSheetUtils.LETTER_PAGE_WIDTH
      );
      let heightDPI = tearSheetUtils.toPx(
        this.userModel.settings.page_format === "A4"
          ? tearSheetUtils.A4_PAGE_HEIGHT
          : tearSheetUtils.LETTER_PAGE_HEIGHT
      );
      let rect = this.workspaceElement.nativeElement.getBoundingClientRect();
      this.zoom = Math.min(MAX_WIDTH / widthDPI, MAX_HEIGHT / heightDPI);
      this.pageContainerHeight = rect.height;
      this.pageContainerWidth = rect.width;
      this.pageHeight = Math.min(
        this.zoom * heightDPI,
        0.95 * this.pageContainerHeight
      );
      this.pageWidth = (this.pageHeight * widthDPI) / heightDPI;
    }
  }

  protected onUploadSuccess() {
    this.loadPDFs();
  }

  protected loadPDFs(): any {
    this.fileService.get("pdf").then((pdfs) => {
      this.pdfs = pdfs;
      if (this.pdfs.length > 0) {
        this.pdfSource = this.pdfs[0];
        this.updatePDFUrl();
      }
    });
  }

  protected pdfSourceChanged() {
    this.updatePDFUrl();
  }
  protected updatePDFUrl() {
    this.pdfURL = null;
    setTimeout(() => {
      this.pdfURL = `${this.baseUrl}/flipbook/view/${this.pdfSource._id}`;
      this.refreshEmbedCode();
    }, 50);
  }

  refreshEmbedCode() {
    this.embedCode = `<iframe src="${this.pdfURL}" style="width: ${this.width}px; height:${this.height}px; border: none"></iframe>`;
  }
}
